import React, { useState } from 'react';
import { Card, Tabs, Typography } from 'antd';
import { MoneyCollectOutlined, CarOutlined, EnvironmentOutlined, CalculatorOutlined, SettingOutlined, TableOutlined } from '@ant-design/icons';
import TollFeePage from './TollFeePage';
import LoadUnloadFeePage from './LoadUnloadFeePage';
import AddEditPricePage from './AddEditPricePage';
import RM2FeePage from './RM2FeePage';
import SystemFeePage from './SystemFeePage';
import ShippingPriceMatrixPage from './ShippingPriceMatrixPage';
import { useLanguage } from '../contexts/LanguageContext';

const { Title } = Typography;
const { TabPane } = Tabs;

const FeeStructurePage: React.FC = () => {
  const { t } = useLanguage();
  const [activeTab, setActiveTab] = useState('price-by-capacity');

  return (
    <div className="container-fluid mt-4">
      <Card>
        <Title level={2} style={{ marginBottom: 24 }}>
          <MoneyCollectOutlined style={{ marginRight: 8, color: '#1890ff' }} />
          {t('fee.structure.management')}
        </Title>
        
        <Tabs 
          activeKey={activeTab} 
          onChange={setActiveTab}
          size="large"
          type="card"
        >
          <TabPane 
            tab={
              <span>
                <TableOutlined />
                {t('price.by.capacity')}
              </span>
            } 
            key="price-by-capacity"
          >
            <ShippingPriceMatrixPage embedded />
          </TabPane>
          
          <TabPane 
            tab={
              <span>
                <EnvironmentOutlined />
                {t('shipping.prices')}
              </span>
            } 
            key="shipping-prices"
          >
            <AddEditPricePage />
          </TabPane>
    
          <TabPane 
            tab={
              <span>
                <CarOutlined />
                {t('toll.fee.management')}
              </span>
            } 
            key="toll-fees"
          >
            <TollFeePage />
          </TabPane>
          
          <TabPane 
            tab={
              <span>
                <MoneyCollectOutlined />
                {t('load.unload.fee.management')}
              </span>
            } 
            key="load-unload-fees"
          >
            <LoadUnloadFeePage />
          </TabPane>
    
          <TabPane 
            tab={
              <span>
                <CalculatorOutlined />
                {t('rm2.fee.management')}
              </span>
            } 
            key="rm2-fees"
          >
            <RM2FeePage />
          </TabPane>

          <TabPane 
            tab={
              <span>
                <SettingOutlined />
                {t('system.fee.management')}
              </span>
            } 
            key="system-fees"
          >
            <SystemFeePage />
          </TabPane>
        </Tabs>
      </Card>
    </div>
  );
};

export default FeeStructurePage;